import React, { Component } from "react";
import PropTypes from "prop-types";

export default class CheckboxGroup extends Component {
  static propTypes = {
    options: PropTypes.array.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func
  };

  static defaultProps = {
    value: []
  };

  onChange = e => {
    const { options, onChange, value } = this.props;
    if (!onChange) return;

    // filter out values that aren't an option
    const values = options.map(o => o.value);
    const nextValue = value.slice().filter(v => values.indexOf(v) > -1);

    const index = nextValue.indexOf(e.target.value);
    if (index > -1 && !e.target.checked) {
      nextValue.splice(index, 1);
    }
    if (index < 0 && e.target.checked) {
      nextValue.push(e.target.value);
    }

    onChange(nextValue.sort((a, b) => values.indexOf(a) - values.indexOf(b)));
  };

  renderOption = (option, i) => {
    const checked =
      this.props.value && this.props.value.indexOf(option.value) > -1;

    return (
      <div className="rf-CheckboxGroup__button" key={i}>
        <label className="rf-CheckboxGroup__label">
          <input
            className="rf-CheckboxGroup__checkbox"
            type="checkbox"
            checked={checked}
            onChange={this.onChange}
            value={option.value}
          />
          <span className="rf-RadioButtonGroup__caption">{option.text}</span>
        </label>
      </div>
    );
  };

  render() {
    const { options } = this.props;

    return (
      <div className="rf-CheckboxGroup">
        {(options || []).map(this.renderOption)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/CheckboxGroup.js